/**
 * 일정 생성 범위
 */
export const SCHEDULING_TERM_MONTH = 3;
